import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageTranslationComponent } from './components/language-translation/language-translation.component';
import { AuthRestConnectorService } from 'app/core/authentication/services/auth-rest-connector.service';
import { MaterialModule } from 'app/material.module';
import { GlobalConstants } from 'app/shared/constants/globalconstants';
import { SiteLogoModule } from 'app/site-logo/site-logo.module';

import { SSOLandingPageLoginComponent } from './components/login/login.component';
import { SSOLandingPageErrorComponent } from './components/error/error.component';
import { SSOLandingPageRoutingModule, routedComponents } from './sso-landing-page-routing.module';

@NgModule({
  imports: [
    CommonModule,
    SSOLandingPageRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    TranslateModule,
    SiteLogoModule,
  ],
  providers: [
    AuthRestConnectorService,
    GlobalConstants,
  ],
  exports: [
    SSOLandingPageLoginComponent,
    SSOLandingPageErrorComponent,
  ],
  entryComponents: [
    SSOLandingPageLoginComponent,
    SSOLandingPageErrorComponent,
  ],
  declarations: [
    routedComponents,
    LanguageTranslationComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SSOLandingPageModule { }
